import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'

import Home from './Home'
import ChooseCountry from './Country'
import { Universities } from './Universities'

class App extends Component {
    render() {
        return (
            <Router>
                <div>
                    <Switch>
                        <Route exact path="/home" component={Home} />
                        <Route exact path="/country" component={ChooseCountry} />
                        <Route exact path="/universities" component={Universities} />
                        <Redirect from="/" to="/home" />
                    </Switch>
                </div>
            </Router>
        )
    }
}

export default App
